<template>
	<notification-container></notification-container>
	<modals-container></modals-container>
	<http-loader></http-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NotificationContainer from './components/utils/notifications/NotificationContainer.vue'
import HttpLoader from './components/utils/HttpLoader.vue'
import ModalsContainer from './components/utils/modals/ModalsContainer.vue'

export default defineComponent({
	components: {
		NotificationContainer, HttpLoader, ModalsContainer
	}
})
</script>

<style lang="scss">

</style>
